export interface DashboardIndicadores {
    criados: number;
    executados: number;
    naoExecutados: number;
    executor: number;
    afericao: number;
    fiscal: number;
    equipamentos: number;
}


export interface IndicadorInfo {
    titulo: string;
    valor: number;
    icone: string;
    cor: string;
    descricao: string;
    periodicidade: string;
}

export interface DashboardIndicadoresGerais {
    equipamentos: number;
    contratos: number;
    beneficiarias: number;
    condutores: number;
    aferidores: number;
    totalDiosCriados: number;
    totalDiosExecutados: number;
    totalDiosCancelados: number;
}
